import TableMate from './src'

TableMate.install = Vue => {
  Vue.component(TableMate.name, TableMate)
}

export default TableMate
